<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  created() {
    // // 获取 hash 值，例如 #/?token=123456
    // const hash = window.location.hash;
    // // 从 hash 中解析 query 参数
    // const queryString = hash.split("?")[1]; // 拿到 token=123456
    // const urlParams = new URLSearchParams(queryString);
    // const token = urlParams.get("token");

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const code = urlParams.get("code");
    if (code) {
      console.log("App.vue 中获取的 token:", code);
      localStorage.setItem("code", code); // 或存到 Vuex
    }
    if (token) {
      console.log("App.vue 中获取的 token:", token);
      localStorage.setItem("token", token); // 或存到 Vuex
    }
    console.log(token, "tokentokentoken");
  },
};
</script>
<style lang="scss">
body {
  padding: 0;
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
